import axios from "axios";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

// The Plan page (/api/plan): the income the kiosks must bring for the saved costs,
// beside what they bring this month. Kept on the page, not in the store.

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch) => {
  // No response: the network or the server is down
  if (!err.response) {
    toastr.error("Сервертэй холбогдож чадсангүй");
    return;
  }
  if (
    err.response.status === 401 &&
    err.response.data.msg === "Token is not valid"
  ) {
    window.localStorage.clear("x-auth-token");
    toastr.error("Session expired");
    dispatch(logout());
  }
  const errors = err.response.data.errors;
  if (errors) {
    errors.forEach((error) => toastr.error(error.msg));
  }
};

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

//  The page as the backend works it out, or null when it could not be loaded
export const getPlan = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/plan");
    return res.data;
  } catch (err) {
    handleError(err, dispatch);
    return null;
  }
};

//  Saves the costs, all at once. Returns { plan }, the page worked out again, or the
//  backend's { errors }.
export const savePlan = (body) => async (dispatch) => {
  try {
    const res = await axios.put("/api/plan", JSON.stringify(body), config);
    toastr.success("Хадгалагдлаа");
    return { plan: res.data };
  } catch (err) {
    handleError(err, dispatch);
    return {
      errors: (err.response && err.response.data.errors) || [],
    };
  }
};
